// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backToList {
  text-align: left;
  width: 33px;
  border-right: 1px #bcbcbc solid;
  border-radius: 0;
  margin-right: 10px;
}

.panelHr {
  margin: 0 0 25px 0;
}

.text-danger {
  margin: 5px 0;
}

.formSection {
  padding: 10px 0 0 0;
}

.responsibilityTable {
  width: 100%;
}

.responsibilityTable th {
  text-align: center;
}

.responsibilityTable th:first-child {
  text-align: left;
}

.responsibilityTable td {
  vertical-align: top;
}

.responsibilityTable td {
  padding: 0 2px;
}

#jobForm a:hover,
#jobForm a:focus {
  color: #6a6a6a;
  text-decoration: underline;
}

.jobsProfilerLabels h4 {
  padding: 0;
}

.jobsProfilerInputs input {
  width: 70%;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  text-align: center;
  margin-top: 3px;
  padding-top: 0 !important;
}

.panelHr {
  margin-bottom: 10px;
}

.jobTalentsData {
  width: 100%;
}

.jobTalentsData td:first-child {
  width: 38px;
}

.talentStatus {
  padding: 5px 0 5px 10px;
  font-size: 1.1rem;
}

.jobTalentsData .dropdown {
  color: #888;
  cursor: pointer;
}

.darkBg {
  background-color: #dfdfdf;
}

.boldText {
  font-family: "MontserratSemiBold", sans-serif;
  font-size: 1rem;
}

.yellowTalent {
  color: #efce7c;
}

.greenTalent {
  color: #78c7af;
}

#innerTextServer {
  width: 100%;
  border: 1px solid #BBB;
  padding: 10px;
  height: 200px;
  overflow-y: scroll;
}

.talentBox {
  height: 95px;
}

.aptitudeTitle {
  height: 30px;
  font-size: 130%;
}

.talentBox div:first-child, .talentBox div:nth-child(2) {
  margin-right: 5px;
}

.talentGraph {
  margin-right: 0;
}

div.surfInPage div {
  width: 100%;
  padding: 5px;
}

/* Dropdown Button */
.dropbtn {
  text-align: right;
  padding: 0 5px 0 5px;
  border: none;
  font-family: "MontserratLight", sans-serif;
  min-width: 145px;
}

.dropbtnSmall {
  width: 160px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  right: -3px;
  z-index: 1;
  background-color: white;
  min-width: 160px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.formWrapper .scoreContainerField {
  width: 50px;
  text-align: center;
}

::ng-deep .responsibilityTable td .mat-mdc-form-field-infix {
  width: 100%;
}

::ng-deep .responsibilityTable td .mat-mdc-form-field-flex,
::ng-deep .responsibilityTable td .mat-mdc-form-field-infix {
  padding-top: 0;
}

::ng-deep .subAccountsWrap .mat-mdc-form-field-label {
  display: none !important;
}

::ng-deep .subAccountsWrap .mat-mdc-form-field-label.mat-mdc-form-field-empty {
  display: block !important;
}

::ng-deep .formWrapper .mat-mdc-form-field {
  width: 100%;
}

::ng-deep .formWrapper .mat-mdc-grid-tile.align-left .mat-mdc-figure {
  justify-content: flex-start;
}

::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure {
  justify-content: flex-end;
}

::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure button:first-child {
  margin-right: 10px;
}

::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure button.margin0 {
  margin: 0;
}

::ng-deep .formSection .mat-mdc-card {
  padding: 0;
  margin-bottom: 20px;
  border: 1px solid #dddddd;
}

::ng-deep .formSection .mat-mdc-card-header {
  padding: 8px 15px;
  background: rgba(0, 0, 0, 0.03);
}

::ng-deep .formSection .mat-mdc-card-header-text {
  margin: 0;
  flex: 1 1 auto;
}

::ng-deep .formSection .mat-mdc-icon-button {
  height: 24px;
  width: 24px;
  line-height: 23px;
}

::ng-deep .mat-mdc-tab-body-content {
  padding-top: 10px;
}

::ng-deep .jobsProfilerOptions {
  min-width: calc(100% + 20px) !important;
}

::ng-deep .jobsProfilerLabels .mat-mdc-grid-tile .mat-mdc-figure {
  justify-content: center !important;
}

::ng-deep .jobsProfilerInputs .mat-mdc-grid-tile .mat-mdc-figure {
  align-items: flex-start !important;
  justify-content: center !important;
}

::ng-deep .jobProfilerSatellite .mat-mdc-grid-tile .mat-mdc-figure {
  justify-content: flex-start !important;
}

::ng-deep .talentStatus div {
  float: none !important;
  display: inline-block;
  margin-left: 0 !important;
}

::ng-deep .talentStatus div div {
  position: relative;
  top: 2px;
}

::ng-deep .talentStatus div div:first-child {
  top: 3px;
}

::ng-deep .talentStatus .clearfix {
  display: none;
}

::ng-deep .error .scoreContainerField {
  color: #dc3545;
}

::ng-deep .scoreBlock .error .mat-mdc-form-field-underline .mat-mdc-form-field-ripple {
  background-color: #dc3545 !important;
}

::ng-deep .scoreBlock .mat-mdc-form-field-flex > .mat-mdc-form-field-infix {
  padding: 0;
  border-top: 0;
}

::ng-deep .scoreBlock .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-label {
  margin-top: -15px;
}

::ng-deep .formSection .mat-mdc-card-header .mat-mdc-card-title {
  font-size: 1.3rem;
  color: rgba(0, 0, 0, 0.54);
  font-weight: 400;
  margin: 0;
}

::ng-deep .formSection .mat-mdc-card-content {
  padding: 8px 15px;
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/mobile/mobile-jobs-edit/mobile-jobs-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;;EAEI,cAAA;EACA,0BAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;EACA,wEAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,6CAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA,oBAAA;AACA;EACI,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;;EAEI,cAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,+BAAA;AACJ;;AAEA;EACI,SAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AACJ;;AAEA;EAAsC,iBAAA;AAEtC;;AAAA;EACI,uCAAA;AAGJ;;AAAA;EACI,kCAAA;AAGJ;;AAAA;EACI,kCAAA;EACA,kCAAA;AAGJ;;AAAA;EACI,sCAAA;AAGJ;;AAAA;EACI,sBAAA;EACA,qBAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,QAAA;AAGJ;;AAAA;EACI,QAAA;AAGJ;;AAAA;EACI,aAAA;AAGJ;;AAAA;EACI,cAAA;AAGJ;;AAAA;EACI,oCAAA;AAGJ;;AAAA;EAA6E,UAAA;EAAY,aAAA;AAKzF;;AAJA;EAAyF,iBAAA;AAQzF;;AANA;EACI,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,SAAA;AASJ;;AANA;EACI,iBAAA;EACA,iBAAA;AASJ","sourcesContent":[".backToList {\n    text-align: left;\n    width: 33px;\n    border-right: 1px #bcbcbc solid;\n    border-radius: 0;\n    margin-right: 10px;\n}\n\n.panelHr {\n    margin: 0 0 25px 0;\n}\n\n.text-danger {\n    margin: 5px 0;\n}\n\n.formSection {\n    padding: 10px 0 0 0;\n}\n\n.responsibilityTable {\n    width: 100%;\n}\n\n.responsibilityTable th {\n    text-align: center;\n}\n\n.responsibilityTable th:first-child {\n    text-align: left;\n}\n\n.responsibilityTable td {\n    vertical-align: top;\n}\n\n.responsibilityTable td{\n    padding: 0 2px;\n}\n\n#jobForm a:hover,\n#jobForm a:focus {\n    color: #6a6a6a;\n    text-decoration: underline;\n}\n\n.jobsProfilerLabels h4 {\n    padding: 0;\n}\n\n.jobsProfilerInputs input {\n    width: 70%;\n    border: 1px solid #cccccc;\n    border-radius: 4px;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n    text-align: center;\n    margin-top: 3px;\n    padding-top: 0 !important;\n}\n\n.panelHr {\n    margin-bottom: 10px;\n}\n\n.jobTalentsData {\n    width: 100%;\n}\n\n.jobTalentsData td:first-child {\n    width: 38px;\n}\n\n.talentStatus {\n    padding: 5px 0 5px 10px;\n    font-size: 1.1rem;\n}\n\n.jobTalentsData .dropdown {\n    color: #888;\n    cursor: pointer;\n}\n\n.darkBg {\n    background-color: #dfdfdf;\n}\n\n.boldText {\n    font-family: 'MontserratSemiBold',  sans-serif;\n    font-size: 1rem;\n}\n\n.yellowTalent{\n    color: #efce7c\n}\n\n.greenTalent{\n    color: #78c7af\n}\n\n#innerTextServer {\n    width: 100%;\n    border: 1px solid #BBB;\n    padding: 10px;\n    height: 200px;\n    overflow-y: scroll;\n}\n\n.talentBox {\n    height: 95px;\n}\n\n.aptitudeTitle {\n    height: 30px;\n    font-size: 130%;\n}\n\n.talentBox div:first-child, .talentBox div:nth-child(2) {\n    margin-right: 5px;\n}\n\n.talentGraph  {\n    margin-right: 0;\n}\n\ndiv.surfInPage div {\n    width: 100%;\n    padding: 5px;\n}\n\n/* Dropdown Button */\n.dropbtn {\n    text-align: right;\n    padding: 0 5px 0 5px;\n    border: none;\n    font-family: 'MontserratLight',  sans-serif;\n    min-width: 145px;\n}\n\n.dropbtnSmall {\n    width: 160px;\n}\n\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    right: -3px;\n    z-index: 1;\n    background-color: white;\n    min-width: 160px;\n    box-shadow: 0 3px 4px 0 rgba(0,0,0,0.2);\n    cursor: pointer;\n}\n\n.formWrapper .scoreContainerField {\n    width: 50px;\n    text-align: center;\n}\n\n::ng-deep .responsibilityTable td .mat-mdc-form-field-infix {\n    width: 100%;\n}\n\n::ng-deep .responsibilityTable td .mat-mdc-form-field-flex,\n::ng-deep .responsibilityTable td .mat-mdc-form-field-infix {\n    padding-top: 0;\n}\n\n::ng-deep .subAccountsWrap .mat-mdc-form-field-label {\n    display: none !important;\n}\n\n::ng-deep .subAccountsWrap .mat-mdc-form-field-label.mat-mdc-form-field-empty {\n    display: block !important;\n}\n\n::ng-deep .formWrapper .mat-mdc-form-field {\n    width: 100%;\n}\n\n::ng-deep .formWrapper .mat-mdc-grid-tile.align-left .mat-mdc-figure  {\n    justify-content: flex-start;\n}\n\n::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure {\n    justify-content: flex-end;\n}\n\n::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure button:first-child {\n    margin-right: 10px;\n}\n\n::ng-deep .formWrapper .mat-mdc-grid-tile .mat-mdc-figure button.margin0 {\n    margin: 0;\n}\n\n::ng-deep .formSection .mat-mdc-card {\n    padding: 0;\n    margin-bottom: 20px;\n    border: 1px solid #dddddd;\n}\n\n::ng-deep .formSection .mat-mdc-card-header {\n    padding: 8px 15px;\n    background: rgba(0,0,0,.03);\n}\n\n::ng-deep .formSection .mat-mdc-card-header-text {\n    margin: 0;\n    flex: 1 1 auto;\n}\n\n::ng-deep .formSection .mat-mdc-icon-button {\n    height: 24px;\n    width: 24px;\n    line-height: 23px;\n}\n\n::ng-deep .mat-mdc-tab-body-content { padding-top: 10px; }\n\n::ng-deep .jobsProfilerOptions {\n    min-width: calc(100% + 20px) !important;\n}\n\n::ng-deep .jobsProfilerLabels .mat-mdc-grid-tile .mat-mdc-figure {\n    justify-content: center !important;\n}\n\n::ng-deep .jobsProfilerInputs .mat-mdc-grid-tile .mat-mdc-figure {\n    align-items: flex-start !important;\n    justify-content: center !important;\n}\n\n::ng-deep .jobProfilerSatellite .mat-mdc-grid-tile .mat-mdc-figure {\n    justify-content: flex-start !important;\n}\n\n::ng-deep .talentStatus div {\n    float: none !important;\n    display: inline-block;\n    margin-left: 0 !important;\n}\n\n::ng-deep .talentStatus div div{\n    position: relative;\n    top: 2px;\n}\n\n::ng-deep .talentStatus div div:first-child {\n    top: 3px;\n}\n\n::ng-deep .talentStatus .clearfix {\n    display: none;\n}\n\n::ng-deep .error .scoreContainerField {\n    color: #dc3545;\n}\n\n::ng-deep .scoreBlock .error .mat-mdc-form-field-underline .mat-mdc-form-field-ripple {\n    background-color: #dc3545 !important;\n}\n\n::ng-deep .scoreBlock .mat-mdc-form-field-flex > .mat-mdc-form-field-infix { padding: 0; border-top: 0}\n::ng-deep .scoreBlock .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-label { margin-top:-15px; }\n\n::ng-deep .formSection .mat-mdc-card-header .mat-mdc-card-title {\n    font-size: 1.3rem;\n    color: rgba(0,0,0,.54);\n    font-weight: 400;\n    margin: 0;\n}\n\n::ng-deep .formSection .mat-mdc-card-content {\n    padding: 8px 15px;\n    font-size: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
